import { SVGProps, Ref, forwardRef } from 'react';

export const ChartBarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1m-.9 17h1.8V6h-1.8zm-3.2 0v-6H6.1v6zm10-8v8h-1.8v-8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChartBarFilledSize24Glyph.displayName = 'ChartBarFilledSize24Glyph';
